/* Just Brilliant device-local saved creations, shared by all product controls. */
(() => {
  if (window.jbWishlistReady) return;
  window.jbWishlistReady = true;
  const selector = '[data-jb-save], .jb-card-save';
  const memory = new Map();
  const handleFor = button => button.dataset.jbSave || button.closest('jb-card-media')?.dataset.handle;
  function read(handle) {
    if (memory.has(handle)) return memory.get(handle);
    try { return localStorage.getItem('jb-saved-' + handle) === 'true'; } catch (_) { return false; }
  }
  function sync() {
    document.querySelectorAll(selector).forEach(button => {
      const handle = handleFor(button);
      if (!handle) return;
      const saved = read(handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? 'Remove this creation from saved items' : 'Save this creation on this device');
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest?.(selector);
    if (!button || button.disabled) return;
    const handle = handleFor(button);
    if (!handle) return;
    event.preventDefault();
    const saved = !read(handle);
    memory.set(handle, saved);
    let persisted = true;
    try { localStorage.setItem('jb-saved-' + handle, String(saved)); } catch (_) { persisted = false; }
    sync();
    const status = button.closest('jb-card-media')?.querySelector('[role="status"]') || button.closest('.jb-product-experience')?.querySelector('.jb-save-status');
    if (status) status.textContent = saved ? (persisted ? 'Creation saved on this device.' : 'Creation saved for this page visit. Device storage is unavailable.') : 'Creation removed from your saved items.';
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      button._jbHeartMotion?.cancel();
      const icon = button.querySelector('svg');
      button._jbHeartMotion = icon?.animate?.([
        { transform: 'scale(1)', opacity: 1 },
        { transform: 'scale(.65)', opacity: .45, offset: .22 },
        { transform: 'scale(1.22)', opacity: 1, offset: .62 },
        { transform: 'scale(1)', opacity: 1 }
      ], { duration: 480, easing: 'cubic-bezier(.22,.61,.36,1)' });
      button.classList.remove('jb-heart-burst');
      clearTimeout(button._jbHeartTimer);
      void button.offsetWidth;
      button.classList.add('jb-heart-burst');
      button._jbHeartTimer = setTimeout(() => button.classList.remove('jb-heart-burst'), 500);
    }
  });
  let scheduled = false;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))))) return;
    if (!scheduled) {
      scheduled = true;
      queueMicrotask(() => { scheduled = false; sync(); });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', event => {
    if (event.key === null) memory.clear();
    else if (event.key.startsWith('jb-saved-')) memory.delete(event.key.slice(9));
    else return;
    sync();
  });
  window.addEventListener('pageshow', () => { memory.clear(); sync(); });
  sync();
})();
